import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import Conexao from '../../../providers/Conexao';
import Layout from '../../Layout';
import fontConfig from '../../../Componentes/FontConfig';
import { useLocation } from 'react-router-dom';
import { OverlayPanel } from 'primereact/overlaypanel';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Tooltip } from 'primereact/tooltip';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { InputSwitch } from "primereact/inputswitch";
import { SpeedDial } from 'primereact/speeddial';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import BotaoEditar from '../../../Componentes/BotaoEditar';
import BotaoExcluir from '../../../Componentes/BotaoExcluir';
import { getDataRepository } from '../../../providers/Repository';
import DisplayStatusEquipamento from './Componentes/DisplayStatusEquipamento';
import { RadioButton } from 'primereact/radiobutton';
import SidebarColetas from './Componentes/SidebarColetas';
import TonerLevel from '../../../Componentes/TonerLevel';
import { Badge } from 'primereact/badge';
import { Slider } from "primereact/slider";
import SidebarDetalheColetas from './Componentes/SidebarDetalheColetas';
import { Chip } from 'primereact/chip';
import { Menu } from 'primereact/menu';
import SidebarFiltrosPrevisao from './Componentes/SidebarFiltrosPrevisao';
import { MultiSelect } from 'primereact/multiselect';
import ModalGraficoConsumo from './Componentes/ModalGraficoConsumo';

import { Calendar } from 'primereact/calendar';


export default function VisaoTrocasSuprimentos(props) {
    const toast = React.useRef(null); // Ref para o Toast
    const [ingredient, setIngredient] = useState('parque');
    const [selectedCores, setSelectedCores] = useState(null);
    const [visible, setVisible] = useState(false);
    const [coleta, setColeta] = useState([])
    const [loading, setLoading] = useState(false);

    const [coletas, setColetas]= useState([]);
    
    const [selectedColetas, setSelectedColetas]= useState([]);
    
    const [selectAll, setSelectAll] = useState(false);

    const [fieldsFound, setFieldsFound] = useState([]);

    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [parametroData, setParametroData] = useState(['',''])
    
    const location = useLocation();

    const { dataEmpresa } = location.state || {};

    const op = useRef(null); // Referência para o OverlayPanel
    const [openFilter, setOpenFilter] = useState(false)
    const requisicaoInicialData = useRef(false); // Referência para o botão de filtro

    const [totalRegistros, setTotalRegistros] = useState(0)
    const [diasPesquisa, setDiasPesquisa] = useState([0,999])

    const [faixaTonerPreto, setFaixaTonerPreto] = useState([0,100])
    const [verCorPreta, setVerCorPreta] = useState(true)
    const [verCorCiano, setVerCorCiano] = useState(true)
    const [verCorMagenta, setVerCorMagenta] = useState(true)
    const [verCorAmarelo, setVerCorAmarelo] = useState(true)
    const [dias, setDias] = useState([1, 365])
    const [openPrevisao, setOpenPrevisao] = useState([])
    const [dataInicial, setDataInicial] = useState('')
    const [dataFinal, setDataFinal] = useState('')

    
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        idempresa: { value: '', matchMode: FilterMatchMode.EQUALS },
        numeroserie: { value: '', matchMode: FilterMatchMode.CONTAINS },
        serialtoneranterior : { value: '', matchMode: FilterMatchMode.CONTAINS },
        serialtonernovo :  { value: '', matchMode: FilterMatchMode.CONTAINS },
        modelo: { value: '', matchMode: FilterMatchMode.CONTAINS },
        marca: { value: '', matchMode: FilterMatchMode.CONTAINS },        
        cor: { value: '', matchMode: FilterMatchMode.CONTAINS }, 
        dataFilter :   {
            operator: 'and',
            constraints: [
                { value: null, matchMode: FilterMatchMode.BETWEEN },
                { value: null, matchMode: FilterMatchMode.BETWEEN }
            ]
        },
    });
    
        useEffect(()=>{
            if(faixaTonerPreto[0] === 0 && faixaTonerPreto[1] === 100){
                return 
            }
            setFilters(prevFilters => ({
                ...prevFilters,
                nivel: {
                    operator: 'and',
                    constraints: [
                        { value: faixaTonerPreto[0], matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
                        { value: faixaTonerPreto[1], matchMode: FilterMatchMode.LESS_THAN_OR_EQUAL_TO }
                    ]
                },
            }));
        }, [faixaTonerPreto])

        useEffect(()=>{
           console.log(filters)
        }, [filters])

        

 useEffect(() => {
        if(!requisicaoInicialData.current){
            getData();
            requisicaoInicialData.current = true
        }else{

        }
        
    }, []);

    const getData = () => {
       
        clearFilters()

        setLoading(true)

        Conexao.post('coletasController/getTrocasToner', {
            idempresa : dataEmpresa.idempresa, 
            idcliente : dataEmpresa.idcliente ? dataEmpresa.idcliente : -1
        })
        .then(response => {

           if(response.status === 200 && response.data.status === 'OK'){
                const temp = response.data.payload
                for(let i = 0; i < temp.length; i++){
                    temp[i].dataFilter = new Date(temp[i].datalog)
                }
                console.log(temp)
                setColetas(response.data.payload)

           }else{

            setColetas([])

           }
           
            setLoading(false)

        }).catch(error => {
            
            setColetas([])

            setLoading(false);

            showMessageToast('error', "Não foi possível recuperar dados")
        });
    };

  
    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };


    const handleFilterChange = (e, field) => {

        const value = e.target.value;
        
        setFilters(prevFilters => ({
            ...prevFilters,
            [field]: { value, matchMode: FilterMatchMode.CONTAINS },
            
        }));
    };

    const [overlayVisible, setOverlayVisible] = useState(false);

    const handleFilterConfirm = () => {
        // Aqui você pode aplicar os filtros ao DataTable ou fazer outras ações necessárias
        setOverlayVisible(false); // Fecha o overlay após aplicar os filtros
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        setGlobalFilterValue(value);
    
        // Atualizar o filtro global
        const _filters = { ...filters };
        _filters['global'].value = value;
        
       
        setFilters(_filters);
    
        // Identificar os campos onde o filtro foi encontrado
      
    };
    
 
    const coresDisponiveis = [
        { name: 'CIANO', value: 'CIANO' },
        { name: 'MAGENTA', value: 'MAGENTA' },
        { name: 'AMARELO', value: 'AMARELO' },
        { name: 'PRETO', value: 'PRETO' }
      ];
    const menuRight = useRef(null);

    const getValidDate = (val) =>{
        const data = new Date(val);
        const yy = String(data.getFullYear()); // últimos dois dígitos do ano
        const mm = String(data.getMonth() + 1).padStart(2, '0'); // mês começa em 0
        const dd = String(data.getDate()).padStart(2, '0'); // dia com zero à esquerda

        const dataFormatada = `${yy}-${mm}-${dd}`;
        console.log(dataFormatada); // saída: "25-04-22"
        return dataFormatada;

    }
    const renderHeader = () => {

        return (

            <React.Fragment>
                
            <div className="flex flex-wrap align-items-center" style={{paddingBottom : '10px', paddingTop : '10px', paddingLeft : '0px'}}>
                <div className="col-12 md:col-10">
                    <div className="flex flex-wrap align-items-center gap-5">
                        <div className='col-12 md:col-2 pl-2 pr-2 '>
                        <IconField iconPosition="left" className='w-full'>
                            <InputIcon className="pi pi-search" />
                            <InputText 
                                value={globalFilterValue} 
                                onChange={onGlobalFilterChange} 
                                disabled = {loading}
                                placeholder="Pesquisa global" 
                                tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                            />
                            
                        </IconField>
                        </div>
                        
                        
                        <div className='col-12 md:col-1 pl-2 pr-2 gap-2'>
                            <div className='flex justify-content-around align-items-center'>
                                <div style={{paddingRight : '5px'}}>
                                    <Button
                                            type="button"
                                            icon="pi pi-calendar"
                                            className="p-button-secondary p-button-sm" 
                                            tooltip="Abrir opções de pesquisa por data de abertura do alerta" tooltipOptions={{ position: 'bottom' }}
                                            onClick={(e) => menuRight.current.toggle(e)}
                                        />
                                        <OverlayPanel ref={menuRight} style={{marginTop: '-94px'}}>
                                            <div className="flex flex-column gap-3 p-2 " >
                                                <span>Data Inicial:</span>
                                                <Calendar 
                                                    showIcon 
                                                    tooltip="Data inicial do filtro de pesquisa" tooltipOptions={{ position: 'bottom' }}
                                                    dateFormat="yy-mm-dd" 
                                                    value={dataInicial}
                                                    onChange={(e) => setDataInicial(e.value)}/>
                                                <span>Data Final:</span>
                                                <Calendar 
                                                    showIcon  
                                                    dateFormat="yy-mm-dd" 
                                                    tooltip="Data final do filtro de pesquisa" tooltipOptions={{ position: 'bottom' }}
                                                    value={dataFinal}
                                                    onChange={(e) => setDataFinal(e.value)}/>
                                                <Button label="Aplicar" icon="pi pi-check" 
                                                    tooltip="Aplicar a data como filtro de dados" 
                                                    tooltipOptions={{ position: 'bottom' }} onClick={(e) => {
                                                
                                                      setFilters(prev => ({
                                                        ...prev,
                                                        dataFilter: {
                                                            value: [new Date(dataInicial) ,new Date(dataFinal)],
                                                            matchMode: FilterMatchMode.BETWEEN
                                                          }
                                                    }));
                                              
                                                      menuRight.current.toggle(e);
                                                    
                                                }}/>
                                            </div>
                                        </OverlayPanel>
                                </div>
                                <Button 
                                    icon="pi pi-filter-slash" 
                                    className="p-button-secondary p-button-sm" 
                                    onClick={clearFilters} 
                                    disabled = {loading}
                                    tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                                />
                        
                                <Button 
                                    icon="pi pi-sync" 
                                    className= "p-button-primary p-button-sm ml-2" 
                                    onClick={getData} 
                                    disabled = {loading}
                                    tooltip="Buscar dados..." tooltipOptions={{ position: 'bottom' }}
                                /> 
                               
                            </div>
                          
                         </div>           
                                
                    </div>
                    
                </div>
                <div className="col-12 md:col-2">
                    
                    
                    <div className='flex justify-content-around align-items-center mt-2'>
                            <span 
                                className="text-xl  p-1 pl-2 pr-2" 
                                style={{backgroundColor : '#1E88E5', color: '#fff',cursor:'pointer', opacity : verCorCiano ? 1 : 0.2, }} 
                                onClick={()=>setVerCorCiano(!verCorCiano)}>C</span>

                            <span 
                                className="text-xl  p-1 pl-2 pr-2 ml-2" 
                                style={{backgroundColor : '#EC407A', color: '#fff', cursor:'pointer', opacity : verCorMagenta ? 1 : 0.2}}
                                onClick={()=>setVerCorMagenta(!verCorMagenta)}>M</span>
                            <span 
                                className="text-xl  p-1 pl-2 pr-2 ml-2" 
                                style={{backgroundColor : '#FFCA28', color: '#fff',cursor:'pointer', opacity : verCorAmarelo ? 1 : 0.2}}
                                onClick={()=>setVerCorAmarelo(!verCorAmarelo)}>Y</span>
                            <span 
                                className="text-xl  p-1 pl-2 pr-2 ml-2" 
                                style={{backgroundColor : '#000', color: '#fff',cursor:'pointer', opacity : verCorPreta ? 1 : 0.2}}
                                onClick={()=>setVerCorPreta(!verCorPreta)}>K</span>
                    </div>
              
                </div>
                
            </div>

            </React.Fragment>

        );
    };
    

    const renderFooter = () => {
        if (fieldsFound.length === 0) {
            return  <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {totalRegistros} 
        </div>
        }
        
        return <>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {totalRegistros} 
        </div>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Filtro encontrado em: {fieldsFound.join(', ')}
        </div>
    </>
    };

    const clearFilters = () => {
        setGlobalFilterValue('');
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            idempresa: { value: '', matchMode: FilterMatchMode.EQUALS },
            numeroserie: { value: '', matchMode: FilterMatchMode.CONTAINS },
            serialtoneranterior : { value: '', matchMode: FilterMatchMode.CONTAINS },
            serialtonernovo :  { value: '', matchMode: FilterMatchMode.CONTAINS },
            modelo: { value: '', matchMode: FilterMatchMode.CONTAINS },
            marca: { value: '', matchMode: FilterMatchMode.CONTAINS },        
            cor: { value: '', matchMode: FilterMatchMode.CONTAINS }, 
            dataFilter :   {
                operator: 'and',
                constraints: [
                    { value: null, matchMode: FilterMatchMode.BETWEEN },
                    { value: null, matchMode: FilterMatchMode.BETWEEN }
                ]
            }, 
        });        
        setFieldsFound([]); // Resetando os campos encontrados
        setFaixaTonerPreto([0,100])
        setVerCorCiano(true)
        setVerCorMagenta(true)
        setVerCorAmarelo(true)
        setVerCorPreta(true)
        setDataInicial('')
        setDataFinal('')
        setDias([1,365])
    };



  
    
    const onSelectionChange = (event) => {
        const value = event.value;
        setSelectedColetas(value);

        // Atualiza o estado do botão "Selecionar Todos"
        const allSelected = coletas.every(c => value.some(s => s.idcoleta === c.idcoleta));
        setSelectAll(allSelected);
    };

    const onSelectAllChange = (event) => {
        const checked = event.checked;

        if (checked) {
            const newSelected = [
                ...coletas.filter(s => !coletas.some(c => c.idcoleta === s.idcoleta)),
                ...coletas
            ];
            setSelectedColetas(newSelected);
        } else {
            const remaining = selectedColetas.filter(s => !coletas.some(c => c.idcoleta === s.idcoleta));
            setSelectedColetas(remaining);
        }

        setSelectAll(checked);
    };

     useEffect(() => {
               
                const corConstraints = [];
    
                if (verCorCiano) corConstraints.push({ value: 'CIANO', matchMode: FilterMatchMode.EQUALS });
                if (verCorMagenta) corConstraints.push({ value: 'MAGENTA', matchMode: FilterMatchMode.EQUALS });
                if (verCorAmarelo) corConstraints.push({ value: 'AMARELO', matchMode: FilterMatchMode.EQUALS });
                if (verCorPreta) corConstraints.push({ value: 'PRETO', matchMode: FilterMatchMode.EQUALS });
            
                setFilters(prevFilters => ({
                    ...prevFilters,
                    cor: {
                        operator: 'or',
                        constraints: corConstraints.length > 0 ? corConstraints : [
                            { value: '---', matchMode: FilterMatchMode.EQUALS } // valor que não existe, bloqueia tudo
                        ]
                    }
                }));
            }, [ verCorCiano, verCorMagenta, verCorAmarelo, verCorPreta]);

    useEffect(()=>{
                if(faixaTonerPreto[0] === 0 && faixaTonerPreto[1] === 100){
                    return 
                }
                setFilters(prevFilters => ({
                    ...prevFilters,
                    nivelabertura: {
                        operator: 'and',
                        constraints: [
                            { value: faixaTonerPreto[0], matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
                            { value: faixaTonerPreto[1], matchMode: FilterMatchMode.LESS_THAN_OR_EQUAL_TO }
                        ]
                    },
                }));
            }, [faixaTonerPreto])

    const renderRotuloCor = (cor) =>{
        switch(cor){
            case 'PRETO': return   <span style={{
                                            backgroundColor: '#000', 
                                            color : '#fff', 
                                            fontSize : '1.2rem',
                                            padding : '2px', 
                                            paddingLeft : '3px', 
                                            paddingRight : '3px', 
                                            borderRadius : '2px'}}>K</span>   
            case 'CIANO': return   <span style={{
                                            backgroundColor: '#1565C0', 
                                            color : '#fff', 
                                            fontSize : '1.2rem',
                                            padding : '2px', 
                                            paddingLeft : '3px', 
                                            paddingRight : '3px', 
                                            borderRadius : '2px'}}>C</span> 
                                            
            case 'MAGENTA': return   <span style={{
                                            backgroundColor: '#C2185B', 
                                            color : '#fff', 
                                            fontSize : '1.2rem',
                                            padding : '2px', 
                                            paddingLeft : '3px', 
                                            paddingRight : '3px', 
                                            borderRadius : '2px'}}>M</span> 
            case 'AMARELO': return   <span style={{
                                            backgroundColor: '#FBC02D', 
                                            color : '#fff', 
                                            fontSize : '1.2rem',
                                            padding : '2px', 
                                            paddingLeft : '3px', 
                                            paddingRight : '3px', 
                                            borderRadius : '2px'}}>Y</span> 
        }

        
    }
    return (
        <Layout loading={loading}>
            <div className="p-2">
              

                <div className="border-round-lg surface-card shadow-0 p-2">
                    {/* Botão para abrir o OverlayPanel */}
                    
                
                        <DataTable
                            header={renderHeader()}  
                           
                            value={coletas}
                            paginator 
                            totalRecords={coletas.length}             
                            rows={10} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                            responsiveLayout="scroll"
                            paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Registro {first} até {last} de {totalRecords} registro(s)" 
                            tableStyle={{ minWidth: '35rem' }}
                            filters={filters} // Aplicando os filtros
                            filterDisplay="menu" // Exibe os filtros como menu pop-up
  
                        >
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '1%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                header="Nivel" 
                                field='nivelabertura'   
                                sortable                          
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <>                               
                                <div className='flex-spacing' >
                                    <TonerLevel                                         
                                        width='30px'
                                        nivel={row.nivel} 
                                        onClick={()=>{
                                            setOpenPrevisao({
                                                open : true, 
                                                cor : row.cor, 
                                                numeroserie : row.numeroserie, 
                                                dataPesquisa : row.datalog 
                                            })
                                        }}
                                        cor={row.cor} />
                                                                                                                                                                              
                                </div>
                                </>
                                }
                                />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '3%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="serialtoneranterior" 
                                header="Nº Unidade" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <span>{row.serialtoneranterior}</span>
                                }
                                sortable 
                           
                                filterPlaceholder="Filtrar pelo nº cartucho" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '3%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="datalog" 
                                header="Data Troca" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <>
                                <span style={{fontSize : '0.8rem'}}>{row.datalog.substr(0,10)}</span><br/>
                                <span style={{fontSize : '0.7rem'}}>{row.horalog?.substr(0,8)}</span>
                                </>
                                }
                                sortable 
                                filterPlaceholder="Filtrar pelo serial" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '3%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="numeroserie" 
                                header="Serial" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <Tag severity="contrast" style={{cursor:'pointer'}} className='w-full' value={row.numeroserie} onClick={()=>{
                                    if(globalFilterValue === row.numeroserie){
                                        setColeta(row)
                                    }else{
                                        setGlobalFilterValue(row.numeroserie)
                                        setFilters(prevFilters => ({
                                                    ...prevFilters,
                                                      global: {
                                                          value: row.numeroserie,
                                                          matchMode: FilterMatchMode.CONTAINS // ou EQUALS, STARTS_WITH etc.
                                                    },
                                                }));
                                    }
                                  
                                }}></Tag>
                                }
                                sortable 
                                filter 
                                filterElement={(options) => (
                                                                    <InputText
                                                                        value={options.value}                                        
                                                                        onChange={(e) => options.filterCallback(e.target.value)}
                                                                        onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                                                        placeholder=""
                                                                        />
                                                                )} 
                                filterPlaceholder="Filtrar pelo serial" />
                             <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '6%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="marca" 
                                header="Marca" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <div>
                                    <span className='text-sm'>{row.marca}</span><br/>                            
                                </div>
                                }
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar pela Marca" />
                                <Column 
                                    bodyStyle={{ fontSize: fontConfig.small , width : '10%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    field="modelo" 
                                    header="Equipamento" 
                                    body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                    <div>
                            
                                        <span className='text-sm'>{row.modelo}</span><br/>
                                    </div>
                                    }
                                    sortable 
                                    filter 
                                    filterElement={(options) => (
                                                                        <InputText
                                                                            value={options.value}                                        
                                                                            onChange={(e) => options.filterCallback(e.target.value)}
                                                                            onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                                                            placeholder=""
                                                                            />
                                                                    )} 
                                    filterPlaceholder="Filtrar pelo modelo" />

                               
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '1%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                header="Nivel" 
                                field='nivelencerramento'   
                                sortable                          
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <>                               
                                <div className='flex-spacing' >
                                    <TonerLevel                                         
                                        width='30px'
                                        nivel={row.nivelnovo} 
                                        cor={row.cor} />
                                                                                                                                                                              
                                </div>
                                </>
                                }
                                />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '3%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="serialtonernovo" 
                                header="Nº Unidade" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <span>{row.serialtonernovo}</span>
                                }
                                sortable 
                        
                                filterPlaceholder="Filtrar pelo nº cartucho" />                           
                               
                        
                                
                        </DataTable>
                    
                </div>                
            </div>

            <OverlayPanel ref={op} style={{ width: '300px' }}>
                    <div className="p-3">
                        <h4>Filtros</h4>
                        
                       
                        <div className="p-field">
                            <label htmlFor="cor">COR</label>
                            <InputText
                                id="cor"
                                value={filters.cor.value}
                                onChange={(e) => handleFilterChange(e, 'cor')}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="cor">Nº Cartucho</label>
                            <InputText
                                id="cor"
                                value={filters.serialtoneranterior.value}
                                onChange={(e) => handleFilterChange(e, 'serialtoneranterior')}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="cor">Nº Cartucho Novo</label>
                            <InputText
                                id="cor"
                                value={filters.serialtonernovo.value}
                                onChange={(e) => handleFilterChange(e, 'serialtonernovo')}
                            />
                        </div>
                        

                     

                        <div className="p-field">
                            <label htmlFor="razaosocial">Marca</label>
                            <InputText
                                id="marca"
                                value={filters.marca.value}
                                onChange={(e) => handleFilterChange(e, 'marca')}
                            />
                        </div>

                        <div className="p-field">
                            <label htmlFor="razaosocial">Modelo</label>
                            <InputText
                                id="modelo"
                                value={filters.modelo.value}
                                onChange={(e) => handleFilterChange(e, 'modelo')}
                            />
                        </div>
                       

                        <Button label="Aplicar Filtro" icon="pi pi-check" onClick={handleFilterConfirm} />
                    </div>
                </OverlayPanel>
             <Toast ref={toast} />
             <SidebarFiltrosPrevisao 
                openFilter ={openFilter} 
                setOpenFilter={setOpenFilter }
                verCorCiano={verCorCiano}
                setVerCorCiano={setVerCorCiano}
                verCorMagenta={verCorMagenta}
                setVerCorMagenta={setVerCorMagenta}
                verCorAmarelo={verCorAmarelo}
                setVerCorAmarelo={setVerCorAmarelo}
                verCorPreta={verCorPreta}
                setVerCorPreta={setVerCorPreta}
                faixaTonerPreto={faixaTonerPreto}
                setFaixaTonerPreto={setFaixaTonerPreto}
                parametroData = {parametroData}
                setParametroData ={setParametroData}
                />
            <SidebarDetalheColetas 
                coleta = {coleta}
                setColeta = {()=>setColeta([])}/>
                <ModalGraficoConsumo 
                    openPrevisao={openPrevisao} 
                    setOpenPrevisao={setOpenPrevisao}/>
        </Layout>
    );
}
